"use client";
import { Button } from "@/components/ui/button";
import { GitHubLogoIcon } from "@radix-ui/react-icons";
import { signIn, type ClientSafeProvider } from "next-auth/react";

interface LoginButtonProps {
 readonly provider: ClientSafeProvider;
}

export default function LoginButton({
  provider,
}: LoginButtonProps) {
  return (
    <Button
      variant="outline"
      className="gap-2 p-10 text-xl"
      onClick={async () => await signIn(provider.id)}
    >
      <GitHubLogoIcon />
      Sign in with {provider.name}
    </Button>
  );
}
